<template>
  <div>
    {{location}}
  </div>
</template>

<script>
  export default {
    name: 'ColumnLocation',
    props: ['row', 'index', 'column'],
    data: () => {
      return {}
    },
    methods: {},
    computed: {
      location: {
        cache: false,
        get: function () {

          let outStringLocation = '';

          if (this.row.city) {
            outStringLocation += this.row.city + ', '
          }
          if (this.row.state) {
            outStringLocation += this.row.state + ', '
          }
          if (this.row.country) {
            outStringLocation += this.row.country
          }

          outStringLocation = outStringLocation === '' ? this.$t('global.not_set') : outStringLocation;
          return outStringLocation
        }
      }
    }
  }
</script>
